export default {
      id: "eye-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "sprite.svg#eye",
      toString: function () {
        return this.url;
      }
    }